// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"376e8f9c","462":"a19a7518","583":"f1c87315","983":"777aee26"}[chunkId] + ".chunk.js";
};